import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

function CookieConsent({ onAccept }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShow(false);
    if (onAccept) {
      onAccept();
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent">
        <div className="cookie-content">
          <h3>🍪 Cookie Consent</h3>
          <p>
            We use cookies to remember your login session and provide a better experience. 
            By accepting, you agree to auto-login when you return to our site.
          </p>
        </div>
        <div className="cookie-buttons">
          <button className="cookie-decline" onClick={handleDecline}>
            Decline
          </button>
          <button className="cookie-accept" onClick={handleAccept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;

